<template>
  <div
    v-resize="onResize"
    light
    class="home"
    :class="$myVuetifyBreakpoint.contentClass"
  >
    <email-verification />
    <mfa-required-banner />
    <title-bar />

    <navigation
      :nav-width="$navWidth"
      :drawer.sync="drawer"
    />

    <v-main>
      <router-view :key="$route.fullPath" />
    </v-main>
  </div>
</template>

<script>

import Navigation from '../components/Navigation'
import PerfectScrollbarCSS from 'perfect-scrollbar/css/perfect-scrollbar.css' // eslint-disable-line no-unused-vars
import EmailVerification from '../components/EmailVerification.vue'
import MfaRequiredBanner from '@/components/auth/mfa/MfaRequiredBanner'

import debounce from 'lodash/debounce'
const _ = { debounce }

export default {
  name: 'Home',
  components: {
    Navigation,
    EmailVerification,
    MfaRequiredBanner
  },
  data: () => ({
    scrollbarRefs: ['navContainer']
  }),
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(value) {
        this.$store.commit('set_drawer', value)
      }
    },
    showSnackbar: {
      get() {
        return this.$store.state.showSnackbar
      },
      set(value) {
        this.$store.commit('set_showSnackbar', value)
      }
    }
  },
  watch: {
    drawer: function () { this.$updatePerfectScrollbars() }
  },
  beforeCreate() {
    this._ = _
  },
  mounted() {
    this.$initPerfectScrollbars()
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer
    },
    onResize: _.debounce(function () {
      this.$updatePerfectScrollbars()
    }, 250)
  }
}
</script>
